/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_SavingInputs */

const en_admin_payments_saving = /** @type {(inputs: Admin_Payments_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving...`)
};

const zh_admin_payments_saving = /** @type {(inputs: Admin_Payments_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存中...`)
};

/**
* | output |
* | --- |
* | "Saving..." |
*
* @param {Admin_Payments_SavingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_payments_saving = /** @type {((inputs?: Admin_Payments_SavingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_SavingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_payments_saving(inputs)
	return zh_admin_payments_saving(inputs)
});
export { admin_payments_saving as "admin.payments.saving" }